import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import React, { useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import moment from "moment";

const DateSelector = styled(Box)`
  .dateSelectorWrapper {
    position: relative;
    button {
      border: none;
      padding: 0;
      font-family: "Raleway", sans-serif;
      &.calender {
        color: #afb2b5;
        background: transparent;
        margin: 0 10px 0 0;
      }
      &.arrow {
        color: #afb2b5;
        background: transparent;
      }
    }
    .MuiSelect-icon {
      display: none;
    }
  }
`;

interface IDropDownButtonProps {
  open: boolean;
  handleToggle: () => void;
  value: string;
  onChange: (e: SelectChangeEvent) => void;
}

const DropDownButton = ({
  open,
  handleToggle,
  value,
  onChange,
}: IDropDownButtonProps) => {


  const today = moment();
  const yearStart = today.startOf('year');
  // Calculate the difference between today and the year start in days
  const daysPassed = moment().diff(yearStart, 'days');
  




  return (
    <DateSelector>
      <Box className="dateSelectorWrapper">
        {/* <Select
          startAdornment={
            <button type="button" className="calender">
              <CalendarMonthIcon />
            </button>
          }
          endAdornment={
            <button type="button" className="arrow">
              <KeyboardArrowDownIcon />
            </button>
          }
          defaultValue={value}
          value={value}
          displayEmpty
          open={open}
          // className="check"
          onClose={handleToggle}
          onClick={handleToggle}
          className="sfg"
          onChange={onChange}
        >
          {/* <MenuItem value="">Select Time</MenuItem> */}
        {/* <MenuItem value="last_7_days">Last 7 Days</MenuItem>
          <MenuItem value="last_30_days">Last 30 Days</MenuItem>
          <MenuItem value="last_3_month">Last 3 Months</MenuItem>
          <MenuItem value="last_6_month">Last 6 Months</MenuItem>
          <MenuItem value="this_year">This Year</MenuItem>
        </Select> */}

        <div className="calender_icon">
          <CalendarMonthIcon />
        </div>

        <select
          // eslint-disable-next-line react/no-unknown-property
          // startAdornment={
          //     <button type="button" className="calender">
          //       <CalendarMonthIcon />
          //     </button>
          //   }

          //   // eslint-disable-next-line react/no-unknown-property
          //   endAdornment={
          //     <button type="button" className="arrow">
          //       <KeyboardArrowDownIcon />
          //     </button>
          //   }

          defaultValue={value}
          value={value}
          // open={open}
          // className="check"
          // onClose={handleToggle}
          // onClick={handleToggle}
          className="sfg" style={{height:"47px"}}
          onChange={onChange}
        >
          <option value={7}>Last 7 Days</option>
          <option value={30}>Last 30 Days</option>
          <option value={90}>Last 3 Months</option>
          <option value={180}>Last 6 Months</option>
          <option value={365}>This Year</option>
        </select>
      </Box>
    </DateSelector>
  );
};

export default DropDownButton;
